module.exports = __webpack_public_path__ + "assets/icon-search-540ba263.png";